// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"0638e522","197":"f768ccfa","672":"ddeb4477"}[chunkId] + ".css";
};